import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary:    "#1B1E64",
          secondary:  "#454aaa",
          error:      "#d32f2f",
          success:    "#16a34a",
          warning:    "#d97706",
          info:       "#1B1E64",
          background: "#f5f5fb",
          surface:    "#ffffff",
        },
      },
    },
  },
});

export default vuetify;

